<template>
    <div class="font-prompt">
        <b-modal :id="modalId"
                 modal-class="modal-success-with-link"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base font-prompt">
                <div class="modal-base-head">
                    <top-bar></top-bar>
                </div>
                <div class="modal-base-body">
                    <div class="text-title">สมัครสมาชิกสำเร็จ</div>
                    <div class="icon-wrapper">
                        <div class="icon-tem">
                            <div class="img-icon left">
                                 <div @click="openlink('https://www.chanel.com/th/', 'click_chanel_website')">
                                    <img src="@/assets/img/case_2@3x.png" class="w-100"/>
                                </div>
                            </div>
                            <div @click="openlink('https://www.chanel.com/th/', 'click_chanel_website')" class="icon-text">
                                เข้าชม Chanel.com
                            </div>
                        </div>
                        <div class="icon-tem">
                            <div class="img-icon">
                                <div @click="openlink('https://www.chanel.com/th/storelocator/', 'click_click_search_branch')">
                                    <img src="@/assets/img/porte_3@3x.png" class="w-100"/>
                                </div>
                            </div>
                            <div>
                                <div class="icon-text" @click="openlink('https://www.chanel.com/th/storelocator/', 'click_click_search_branch')">
                                    ค้นหาบูติค
                                </div>
                            </div>
                        </div>
                    </div><!-- row -->
                </div><!-- modal-base-body -->

                <div class="modal-base-footer">
                    <div class="close-chanel" >กลับไปที่ CHANEL LINE ACCOUNT
                        <span @click="openLineChanel()" class="click">คลิก</span>
                    </div>
                </div>

            </div><!-- modal-base -->
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import TopBar from "@/components/TopBar.vue";
import Account from "@/helper/AccountHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
    name: "ModalSuccessWithLink",
    props: {
        busModal: Object,
    },
    components: {
        TopBar,
    },
    data: function() {
        return {
            modalId: 'modal-success-with-link',
            tracking: new TrackingService(this),
        };
    },
    created: function() {
    },
    mounted: function() {
        this.busModal.$on('showModal', this.showModal);
        this.busModal.$on('hideModal', this.hideModal);
    },
    methods: {
        showModal: function() {

            this.tracking.screenName("regis_success");
            this.tracking.event("regis_success", "view_regis_success");

            this.$bvModal.show(this.modalId);
        },
        hideModal: function() {
            this.$bvModal.hide(this.modalId);
        },
        openLineChanel: function () {

            var url = Vue.bzbsConfig.linkLineChanel;
            window.open(url);
        },
        openlink: function (link, event) {

        this.tracking.event("regis_success", event);
            //alert(link);
            //window.open(link);
            if (Account.getCacheCustom("Formliff")) {

               window.JsFunction.openWeb(link);

            } else {
                window.open(link);
            }
            // window.JsFunction.openWeb(link);
        }
    },
}
</script>
<style lang="scss">
    @import "@/style/base/component/modal/ModalFullScreen.scss";

    .modal-success-with-link {
        @extend %modal-base;

        .modal-dialog {

            .modal-content {

                .modal-body {

                    background-color: white;
                    padding: 0;

                    .modal-base {

                        padding:0;

                        .modal-base-body {
                            .text-title {
                                font-size: 1rem;
                                font-family: 'bold';
                                text-align: center;
                                padding-top: 30px;
                                padding-bottom: 10vh;
                            }

                            .icon-wrapper {
                                display: flex;
                                justify-content: center;
                                .icon-tem{
                                    width: 48%;
                                }

                                .icon-text {
                                    text-align: center;
                                    font-size: 0.8rem;
                                }
                            }
                        }
                        .close-chanel {
                            text-align: center;
                            font-size: 0.8rem;
                            color: #262626;

                            .click {
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }
        }



        .img-icon {
            max-width: 100px;
            margin: auto;
            padding-bottom: 20px;
            &.left {
                padding-top: 20px;
            }
        }

    }
</style>
